import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import TicketsView from './TicketsView.vue';

const TICKET_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'jov_tickets_index',
    component: TicketsView,
    meta: {
      permissions: TICKET_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.JOV_TICKETS,
    },
  },
  {
    path: frontendURL('accounts/:accountId/tickets/:ticketId'),
    name: 'jov_tickets_show',
    component: TicketsView,
    meta: {
      permissions: TICKET_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.JOV_TICKETS,
    },
  },
];
